<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Logo',
})
</script>
<template>
  <div class="side_logo_container">
    <!-- <router-link :to="{ name: 'dashboard' }">
      <SvgIcon name="logo" />
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link> -->
    <div class="row_center" style="cursor: pointer" @click="toPath">
      <img src="@/assets/logo.png" class="side_logo" />
      <img src="@/assets/logo_text.png" class="side_logo_text" v-if="showTitle" />
    </div>
  </div>
</template>

<script lang="ts" setup name="Logo">
import SvgIcon from '@/components/SvgIcon/index.vue'
import { useRouter } from 'vue-router'
const router = useRouter()

const props = defineProps({
  title: {
    type: String,
    default: '云枢智教运营',
    required: false
  },
  showTitle: {
    type: Boolean,
    default: true,
    required: false
  }
})

const toPath = () => {
  router.push({ name: 'dashboard' })
}
</script>

<style lang="less" scoped>
.side_logo_container {
  padding: 15px 25px;
}
.side_logo {
  width: 35px;
  height: 35px;
  margin-right: 20px;
}
.side_logo_text {
  width: 90px;
  aspect-ratio: 3.5/1;
}
</style>